import { render } from "./leftRecord.vue?vue&type=template&id=73b2d843&scoped=true"
import script from "./leftRecord.vue?vue&type=script&lang=js"
export * from "./leftRecord.vue?vue&type=script&lang=js"

import "./leftRecord.vue?vue&type=style&index=0&id=73b2d843&lang=scss&scoped=scoped"
import "./leftRecord.vue?vue&type=style&index=1&id=73b2d843&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b2d843"]])

export default __exports__